/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { PackageType } from "~/generated/graphql";
import { FilterType } from "./types";

export function mapFilterTypeToPackageType(
  filterQuery: FilterType
): PackageType | null {
  switch (filterQuery) {
    case FilterType.INSTALLED:
      return PackageType.Installed;
    case FilterType.PENDING_REBOOT:
      return PackageType.PendingReboot;
    case FilterType.UPDATED:
      return PackageType.Updated;
    case FilterType.AVAILABLE:
      return PackageType.Available;
    case FilterType.REMOVED:
      return PackageType.Removed;
    case FilterType.FAILED:
      return PackageType.Failed;
    default:
      return null;
  }
}
